import { useEffect, useRef } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { recordMailPrefillSplitTest } from '../../AnonymousSplitTest/recordMailPrefillSplitTest';
import { useGetMailPrefillQuery } from '../../api/mailPrefill/useGetMailPrefillQuery';
import logger from '../../utils/logger';
import RouteSpinner from '../RouteSpinner/RouteSpinner';

/**
 * Landing page for the mail-token prefill flow. A physical letter sends the
 * recipient here with a `?token=`. We resolve the token to a company_number
 * and hand off to the existing `new` step prefill
 */
const MailPrefillUK = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? undefined;
  const hasRedirectedRef = useRef(false);

  const {
    mailPrefill,
    isPendingMailPrefill,
    isMailPrefillError,
    mailPrefillErrorStatus,
  } = useGetMailPrefillQuery(token);

  useEffect(() => {
    if (hasRedirectedRef.current) return;

    if (token && isPendingMailPrefill) return;

    hasRedirectedRef.current = true;

    void recordMailPrefillSplitTest();

    if (token && isMailPrefillError) {
      logger.error('Mail prefill token lookup failed', {
        statusCode: mailPrefillErrorStatus,
      });
    }

    const companyNumber = mailPrefill?.company_number;

    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete('token');
    if (companyNumber) {
      nextParams.set('company_number', companyNumber);
    }

    const queryString = nextParams.toString();
    navigate(`/apply/new${queryString ? `?${queryString}` : ''}`, {
      replace: true,
    });
  }, [
    isPendingMailPrefill,
    isMailPrefillError,
    mailPrefill,
    mailPrefillErrorStatus,
    navigate,
    searchParams,
    token,
  ]);

  return <RouteSpinner />;
};

export default MailPrefillUK;
